import DocumentObjectType from "Areas/SharedFeatures/documentObjectType";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import { OPTION_TYPE } from "Common/dictionaries/optionType";
import OptionForm from "Components/optionForm";
import { DivWithTooltip } from "Components/withPopover";
import classNames from "classnames";
import compact from "lodash/compact";
import find from "lodash/find";
import head from "lodash/head";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { memo, useCallback, useMemo } from "react";
import locale from "./attributes.locale";
const optionFormContainer = React.createElement("div", null);
const labelMarkStyle = {
    transform: "translateY(-0.5em)",
    paddingLeft: 2
};
function Attributes(props) {
    const documentObject = useMemo(() => props.documentObjects
        ? props.documentObjects[props.documentObjectId]
        : undefined, [props.documentObjectId, props.documentObjects]);
    const singleNodeDocumentObject = useMemo(() => {
        if (!documentObject)
            return undefined;
        return {
            DocumentObjectIconId: documentObject.IconId,
            DocumentObjectName: documentObject.Name,
            NodeId: props.nodeId,
            Attributes: documentObject.Attributes
        };
    }, [props.nodeId, documentObject]);
    const handleOptionChange = useCallback((optionId, value) => {
        var _a;
        if (props.onDataUpdate && singleNodeDocumentObject) {
            const currentOptionType = (_a = find(singleNodeDocumentObject.Attributes, [
                "Key",
                optionId
            ])) === null || _a === void 0 ? void 0 : _a.Type;
            currentOptionType && props.onDataUpdate(props.nodeId, optionId, value, currentOptionType);
        }
    }, [props.nodeId, props.onDataUpdate, singleNodeDocumentObject]);
    const labelMark = useMemo(() => (React.createElement(DivWithTooltip, { zIndex: props.zIndex, className: "flex-box-centered-content animate-hover-color line-height-1", popoverContent: locale.ATTRIBUTE_FOR_BUILDING_NAME_AND_RUN_METHODS, style: labelMarkStyle },
        React.createElement("i", { className: "icon-info-filled rotate-180 text-gray-300 font-base" }))), [props.zIndex]);
    const optionsForm = useMemo(() => singleNodeDocumentObject && props.attributeValues
        ? compact(map(singleNodeDocumentObject.Attributes, item => {
            var _a;
            const value = (_a = find(props.attributeValues, ["Key", item.Key])) === null || _a === void 0 ? void 0 : _a.Value;
            if (!props.onDataUpdate &&
                ((!isBoolean(value) && !value) || (isArray(value) && isEmpty(value))))
                return null;
            return (React.createElement(OptionForm, { className: "pt-0_25 pb-0_25", widgetClassName: classNames(item.Type !== OPTION_TYPE.BOOL && "w-100"), value: value, defaultValue: item.Type === OPTION_TYPE.IMAGE && (documentObject === null || documentObject === void 0 ? void 0 : documentObject.IconId)
                    ? documentObjectIconMap[documentObject.IconId]
                    : undefined, labelMark: includes(documentObject === null || documentObject === void 0 ? void 0 : documentObject.LabelAttributes, item.Key) ? labelMark : undefined, key: item.Key, optionId: item.Key, optionName: item.Name, optionType: item.Type, container: optionFormContainer, titleClassName: "font-small text-overflow-ellipsis pb-0_25 pt-0_25 grid-cols-auto no-gap", onChange: props.onDataUpdate ? handleOptionChange : undefined, zIndex: props.zIndex, onGetPreview: props.onGetPreview
                    ? (completed, rejected) => props.onGetPreview &&
                        props.onGetPreview(item.Key, props.largeAttributeValues
                            ? head(props.largeAttributeValues[item.Key])
                            : undefined, completed, rejected)
                    : undefined }));
        }))
        : undefined, [
        props.attributeValues,
        props.largeAttributeValues,
        documentObject,
        props.zIndex,
        singleNodeDocumentObject,
        props.onDataUpdate,
        props.onGetPreview,
        handleOptionChange,
        labelMark
    ]);
    return (React.createElement("div", { className: props.className },
        singleNodeDocumentObject && (React.createElement("div", null,
            React.createElement("div", { className: "text-light-on-surface-variant font-small" }, locale.TYPE),
            React.createElement(DocumentObjectType, { className: "w-100", data: singleNodeDocumentObject }))),
        optionsForm));
}
export default memo(Attributes);
